import { createContext } from 'react';

import type { PagePropertiesManager } from './doc-properties-manager';

// @ts-expect-error this should always be set
export const managerContext = createContext<PagePropertiesManager>();
